import React, { FC, PropsWithChildren } from 'react'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model'
import { openPPAPaymentAuthModal, useApplePaylaterLinkParams, useAppDispatch, useIsBillingAgreementApprovalProcess } from '../../state'
import { Link, ColorTypes } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'

interface PaymentAuthorizationLinkProps extends PropsWithChildren {
  color?: ColorTypes
}

export const PaymentAuthorizationLink: FC<PaymentAuthorizationLinkProps> = ({ children, color }) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const isBillingAgreementApprovalProcess = useIsBillingAgreementApprovalProcess()
  const { instrument } = useMonitoringWithEnduringEventProperties()
  const withApplePaylaterParams = useApplePaylaterLinkParams()

  const onPaymentAuthLinkClick = (): void => {
    if (isBillingAgreementApprovalProcess) {
      return
    }

    dispatch(openPPAPaymentAuthModal())
  }

  return (
    <Link
      target={isBillingAgreementApprovalProcess ? '_blank' : undefined}
      href={isBillingAgreementApprovalProcess ? withApplePaylaterParams(t('common:termsOfPaymentAuthorizationUrl')) : undefined}
      kind='Underline'
      color={color}
      fontFace='CashSansMono'
      testNameSpace='ppa-link-payment'
      key='summary-payment-authorization'
      onClick={instrument(TrackingEvent.PRESSED_SUMMARY_PAYMENT_AUTHORISATION_LINK, onPaymentAuthLinkClick)}
    >
      {children}
    </Link>
  )
}
